module.exports = "/images/more-dots.svg";